import {useAuth} from "@soap/modules";
import {useStyletron} from "baseui";
import React, {useState} from "react";
import {AppNavBar} from "baseui/app-nav-bar";
import logo from "../z30-images/logo_lyw_200.png";
import {LoginControls} from "./login-controls";
import {DesktopOnly, MobileOnly} from "./layout";

function NavLogo() {
    return (
        <a href="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
            <img src={logo} alt="Learn Your Way" style={{ height: 56, width: "auto", objectFit: "contain" }} />
        </a>
    );
}

const UNAUTH_NAV_ITEMS = [
    { label: "Home", url: "/" },
    { label: "Features", url: "/features" },
    { label: "Mission", url: "/mission" },
    { label: "Home Education", url: "/home-education" },
    { label: "Learning Packages", url: "/learning-plans" },
    { label: "Help", url: "/help" },
];

// Leading "/" so hash routes work from non-root pages (e.g. /learning-plans uses MemoryRouter — "#/app" would stay on that document)
const AUTH_NAV_ITEMS = [
    { label: "Home", url: "/#/app" },
    { label: "Control Panel", url: "/#/app/settings" },
    { label: "Learning Packages", url: "/learning-plans" },
];

function CustomUnauthNavBar() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [css] = useStyletron();
    const linkStyles = {
        color: "#64748b",
        textDecoration: "none",
        fontSize: "15px",
        fontWeight: 400,
        padding: "6px 14px",
        borderRadius: 8,
        transition: "background-color 0.2s, color 0.2s",
        margin: "0 14px",
    };
    return (
        <div className={css({
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: 12,
            paddingTop: 4,
            paddingBottom: 12,
        })}>
            <NavLogo />
            <DesktopOnly>
                <nav className={css({
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    gap: 48,
                    alignItems: "center",
                })}>
                    {UNAUTH_NAV_ITEMS.map(({ label, url }) => (
                        <a
                            key={url}
                            href={url}
                            className={css({
                                ...linkStyles,
                                ":hover": {
                                    backgroundColor: "rgba(28, 83, 117, 0.06)",
                                    color: "#1c5375",
                                },
                            })}
                        >
                            {label}
                        </a>
                    ))}
                </nav>
            </DesktopOnly>
            <MobileOnly>
                <button
                    className={css({
                        background: "#f1f5f9",
                        border: "none",
                        cursor: "pointer",
                        padding: "8px 12px",
                        fontSize: 18,
                        borderRadius: 8,
                        color: "#1c5375",
                    })}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Menu"
                >
                    ☰
                </button>
                {mobileMenuOpen && (
                    <nav className={css({
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        marginTop: 8,
                        background: "white",
                        padding: 16,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        zIndex: 1000,
                        borderRadius: 8,
                        border: "1px solid #e2e8f0",
                    })}>
                        {UNAUTH_NAV_ITEMS.map(({ label, url }) => (
                            <a
                                key={url}
                                href={url}
                                className={css({
                                    color: "#1c5375",
                                    textDecoration: "none",
                                    padding: "10px 12px",
                                    borderRadius: 8,
                                    fontWeight: 500,
                                    ":hover": { backgroundColor: "rgba(28, 83, 117, 0.08)" },
                                })}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                {label}
                            </a>
                        ))}
                    </nav>
                )}
            </MobileOnly>
            <LoginControls />
        </div>
    );
}

function CustomAuthNavBar() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [css] = useStyletron();
    const linkStyles = {
        color: "#64748b",
        textDecoration: "none",
        fontSize: "15px",
        fontWeight: 400,
        padding: "6px 14px",
        borderRadius: 8,
        transition: "background-color 0.2s, color 0.2s",
        margin: "0 14px",
    };
    return (
        <div className={css({
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: 12,
            paddingTop: 4,
            paddingBottom: 12,
        })}>
            <NavLogo />
            <DesktopOnly>
                <nav className={css({
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    gap: 48,
                    alignItems: "center",
                })}>
                    {AUTH_NAV_ITEMS.map(({ label, url }) => (
                        <a
                            key={url}
                            href={url}
                            className={css({
                                ...linkStyles,
                                ":hover": {
                                    backgroundColor: "rgba(28, 83, 117, 0.06)",
                                    color: "#1c5375",
                                },
                            })}
                        >
                            {label}
                        </a>
                    ))}
                </nav>
            </DesktopOnly>
            <MobileOnly>
                <button
                    className={css({
                        background: "#f1f5f9",
                        border: "none",
                        cursor: "pointer",
                        padding: "8px 12px",
                        fontSize: 18,
                        borderRadius: 8,
                        color: "#1c5375",
                    })}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Menu"
                >
                    ☰
                </button>
                {mobileMenuOpen && (
                    <nav className={css({
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        marginTop: 8,
                        background: "white",
                        padding: 16,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        zIndex: 1000,
                        borderRadius: 8,
                        border: "1px solid #e2e8f0",
                    })}>
                        {AUTH_NAV_ITEMS.map(({ label, url }) => (
                            <a
                                key={url}
                                href={url}
                                className={css({
                                    color: "#1c5375",
                                    textDecoration: "none",
                                    padding: "10px 12px",
                                    borderRadius: 8,
                                    fontWeight: 500,
                                    ":hover": { backgroundColor: "rgba(28, 83, 117, 0.08)" },
                                })}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                {label}
                            </a>
                        ))}
                    </nav>
                )}
            </MobileOnly>
            <LoginControls />
        </div>
    );
}

export function NavBar() {

    const {
        isAuthenticated,
        authEnabled,
        authReady,
    } = useAuth()

    // Show loading state until authentication is fully ready
    if (!authReady || !authEnabled) {
        return <AppNavBar title="Loading..."/>;
    }

    // Only show navigation once we have definitive authentication state
    return isAuthenticated ? <GetAuthenticatedNavBar/> : <GetNavBar/>;
}



function GetAuthenticatedNavBar() {
    return <CustomAuthNavBar />;
}

function GetNavBar() {
    return <CustomUnauthNavBar />;
}